import { useEffect } from "react";

import { useRoomContext } from "@livekit/components-react";

/**
 * With disconnectOnPageLeave off, nothing else leaves the room once the
 * browser's unload prompt is accepted; pagehide only fires after that.
 */
export function DisconnectOnPageHide() {
  const room = useRoomContext();
  useEffect(() => {
    const leave = () => void room.disconnect();
    window.addEventListener("pagehide", leave);
    return () => window.removeEventListener("pagehide", leave);
  }, [room]);
  return null;
}
